import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import firebase from 'firebase/app';
import 'firebase/messaging';
import {FirebaseMessagePayload} from '@models/firebase.model';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  firebaseMessaging: firebase.messaging.Messaging;
  messagingObservable: Observable<FirebaseMessagePayload>;

  constructor() {
  }

  initFirebase(): void {
    const app = firebase.initializeApp(environment.firebase);
    this.firebaseMessaging = firebase.messaging();
  }

  isNotificationApiSupported(): boolean {
    return firebase.messaging.isSupported();
  }

  getToken(): Promise<string> {
    return this.firebaseMessaging.getToken();
  }

  receiveMessage(): Observable<FirebaseMessagePayload> {
    if (!this.messagingObservable) {
      this.messagingObservable = new Observable<FirebaseMessagePayload>(observe => {
        this.firebaseMessaging.onMessage(payload => {
          observe.next(payload);
        });
      });
    }

    return this.messagingObservable;
  }
}
